// extracted by mini-css-extract-plugin
export default {"generalTab":"GeneralTab_generalTab__J9vK+","active":"GeneralTab_active__+dZW+","unavailable":"GeneralTab_unavailable__mR8kR"};